import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { appContext } from "../context/ContextProvider";
// import BeneficiaryForm from "../pages/Beneficiary/components/AddBeneficiaryPersonalDataForm";

import Dashboard from "../pages/Dashboard/Dashboard";
import PreAuth from "../pages/PreAuth";
import Claims from "../pages/Claims";
import Communications from "../pages/Communications";
import Cancellation from "../pages/Cancellation";
import Physician from "../pages/Physicians";
import PriceList from "../pages/PriceList";
import PreAuthList from "../pages/PreAuth/PreAuthList";
import PreAuthForm from "../pages/PreAuth/components/PreAuthForm";
import ApprovalStatusMonitor from "../pages/PreAuth/ApprovalStatusMonitor";
import Payments from "../pages/Payments";
import PaymentsList from "../pages/Payments/PaymentsList";
import Eligibility from "../pages/Eligibility";
import EligibilityList from "../pages/Eligibility/EligibilityList";
import EligibilityImportJobs from "../pages/Eligibility/EligibilityImportJobs";
import EligibilityImportJobDetail from "../pages/Eligibility/EligibilityImportJobDetail";
import Beneficiary from "../pages/Beneficiary";
import BeneficiaryForm from "../pages/Beneficiary/BeneficiaryForm";
import BeneficiaryList from "../pages/Beneficiary/BeneficiaryList";
import BeneficiaryDetails from "../pages/Beneficiary/BeneficiaryDetails";
import EligibilityDetails from "../pages/Eligibility/components/responseEligbility/EligibilityDetails";
import PreAuthDetails from "../pages/PreAuth/components/PreAuthDetails";
import ClaimsList from "../pages/Claims/ClaimsList";
import SubmitClaims from "../pages/Claims/SubmitClaims";
import ClaimsForm from "../pages/Claims/components/ClaimsForm";
import ClaimsDetails from "../pages/Claims/components/ClaimsDetails";
import EditBeneficiaryForm from "../pages/Beneficiary/EditBeneficiaryForm";
import PhysiciansList from "../pages/Physicians/PhysiciansList";
import PhysiciansForm from "../pages/Physicians/PhysiciansForm";
import PriceListMain from "../pages/PriceList/PriceListMain";
import PriceListSpecificPayer from "../pages/PriceList/PriceListSpecificPayer";
import ClaimHistoryList from "../pages/Claims/ClaimHistoryList";
import ClaimUploadList from "../pages/Claims/ClaimUploadList";
import ClaimsSubmitStats from "../pages/Claims/components/ClaimsSubmitStats";
import CommunicationsList from "../pages/Communications/CommunicationsList";
import CancellationList from "../pages/Cancellation/CancellationList";
import GssReportMain from "../pages/Claims/gssReport/GssReportMain";
import ClaimReportMain from "../pages/Claims/claimReport/ClaimReportMain";
import TpaClaimsReportMain from "../pages/Claims/tpaReport/TpaClaimsReportMain";
import ClaimRejectionReportMain from "../pages/Claims/rejectionReport/ClaimRejectionReportMain";
import SuperAdmin from "../pages/SuperAdmin/index";
import SuperAdminDashboard from "../pages/SuperAdmin/Dashboard/SuperAdminDashboard";
import UserManagement from "../pages/SuperAdmin/UserManagment/UserManagement";
import PreAuthUpdate from "../pages/SuperAdmin/PreAuthUpdate/PreAuthUpdate";
import SfdaMedicineList from "../pages/SuperAdmin/SfdaMedicine/SfdaMedicineList";
import SfdaMedicineForm from "../pages/SuperAdmin/SfdaMedicine/SfdaMedicineForm";
import IcdCodesList from "../pages/SuperAdmin/IcdCodes/IcdCodesList";
import SfdaMedicineIndex from "../pages/SfdaMedicine/index";
import NewSfdaMedicineList from "../pages/SfdaMedicine/SfdaMedicineList";
import NewSfdaMedicineForm from "../pages/SfdaMedicine/SfdaMedicineForm";
import SfdaMedicineDetail from "../pages/SfdaMedicine/SfdaMedicineDetail";

import Ocr from "../pages/ocr/Ocr";
import OcrMain from "../pages/ocr/components/OcrMain";
import AdvancePreAuth from "../pages/PreAuth/AdvancePreAuth";
import DenialManagement from "../pages/Claims/DenialManagement";
import Reports from "../pages/Eligibility/components/reports/Reports";
import Manager from "../pages/PreAuth/components/manager/Manager";
import Report from "../pages/PreAuth/components/report/Report";
import ClaimReports from "../pages/Claims/reports/ClaimReports";
import Index from "../pages/payermanagement/Index";
import Policy from "../pages/policy";
import MainReports from "../pages/Reports";
import PayerManagement from "../pages/payermanagement/PayerManagement";
import MainPage from "../pages/policy/MainPage";
import ReportCard from "../pages/Reports/ReportCard";
import PayerManagementForm from "../pages/payermanagement/PayerManagementForm";
import NPR from "../pages/npr/index";
import NprPayerLevel from "../pages/npr/NprPayerLevel";
import NprPolicyLevel from "../pages/npr/NprPolicyLevel";
import CreatePriceListForm from "../pages/PriceList/CreatePriceListForm";
import ClaimsProcessing from "../pages/Claims/ClaimsProcessing";
import UcafPage from "../pages/Claims/components/ucaf/UcafPage";
import DcafPage from "../pages/Claims/components/ucaf/DcafPage";
import UnderDevelopment from "../shared/UnderDevelopment";
import ReportSummary from "../pages/reports-summary/ReportSummary";
import HelpDeskIndex from "../pages/helpDesk/index";
import HelpDesk from "../pages/helpDesk/HelpDesk";
import AramcoHelpDesk from "../pages/helpDesk/AramcoHelpDesk";
import AdvancePreAuthDetails from "../pages/PreAuth/AdvancePreAuthDetails";
import PaymentDetails from "../pages/Payments/PaymentDetails";
import ClaimErrorList from "../pages/Claims/ClaimErrorList";
import ClaimDiagnosisBulkReplace from "../pages/Claims/ClaimDiagnosisBulkReplace";
import ClaimDiagnosisBulkJobDetails from "../pages/Claims/ClaimDiagnosisBulkJobDetails";
import ClaimItemBulkReplace from "../pages/Claims/ClaimItemBulkReplace";
import ClaimItemBulkJobDetails from "../pages/Claims/ClaimItemBulkJobDetails";
import ClaimReferralBulkUpdate from "../pages/Claims/ClaimReferralBulkUpdate";
import ClaimReferralBulkJobDetails from "../pages/Claims/ClaimReferralBulkJobDetails";
import ClaimsBulkPage from "../pages/Claims/ClaimsBulkPage";
import ClaimsAiAgent from "../pages/Claims/ClaimsAiAgent";
import PreAuthAiAgent from "../pages/PreAuth/PreAuthAiAgent";
import NHIC from "../pages/NHIC";
import NHICSettings from "../pages/NHIC/NHICSettings";
import HealthIDLookup from "../pages/NHIC/HealthIDLookup";
import IntegrationLogs from "../pages/IntegrationLogs";
import GeneratedReportRoute from "../components/GeneratedReportRoute";

// import MainDash from "../pages/Dashboard/components/MainDash/MainDash";

function Router(props) {
  const { user, setUser, setToken, setPermissions, permissions } =
    useContext(appContext);
  return (
    <Routes>
      <Route
        path="dashboard"
        element={user?.RoleId == "12" ? <SuperAdminDashboard /> : <Dashboard />}
      >
        {/* <Route index element={<MainDash />} /> */}
      </Route>
      <Route
        path="approval-status-monitor"
        element={<ApprovalStatusMonitor />}
      />
      <Route path="beneficiary" element={<Beneficiary />}>
        <Route index element={<BeneficiaryList />} />
        <Route path="form" element={<BeneficiaryForm />} />
        <Route path="edit/form" element={<EditBeneficiaryForm />} />
        <Route path="details" element={<BeneficiaryDetails />} />
      </Route>
      <Route path="eligibility" element={<Eligibility />}>
        <Route index element={<EligibilityList />} />
        <Route path="details" element={<EligibilityDetails />} />
        <Route path="import-jobs" element={<EligibilityImportJobs />} />
        <Route path="import-jobs/:jobId" element={<EligibilityImportJobDetail />} />
        <Route path="reports" element={<Reports />} />
      </Route>
      <Route path="preauth" element={<PreAuth />}>
        <Route index element={<PreAuthList />} />
        <Route path="form" element={<PreAuthForm />} />
        <Route path="details" element={<PreAuthDetails />} />
        <Route path="details/:id" element={<PreAuthDetails />} />
        <Route path="edit/form/:id" element={<PreAuthForm />} />
        <Route path="edit/form/:id/:followUp" element={<PreAuthForm />} />
        <Route path="advance/preauth" element={<AdvancePreAuth />} />
        <Route
          path="advance/preauth/details"
          element={<AdvancePreAuthDetails />}
        />
        <Route path="manager" element={<Manager />} />
        <Route path="ai-agent" element={<PreAuthAiAgent />} />
        <Route path="report" element={<Report />} />
        <Route
          path="report/pre-auth"
          element={<GeneratedReportRoute reportId="preauth-report" />}
        />
        <Route
          path="report/approved"
          element={<GeneratedReportRoute reportId="preauth-approved-items" />}
        />
        <Route
          path="report/rejected"
          element={<GeneratedReportRoute reportId="preauth-rejected-items" />}
        />
        <Route path="report/impacts" element={<UnderDevelopment />} />
        <Route path="report/impacts/kpi" element={<UnderDevelopment />} />
      </Route>
      <Route path="npr" element={<NPR />}>
        <Route index path="payer-level" element={<NprPayerLevel />} />
        <Route index path="policy-level" element={<NprPolicyLevel />} />
      </Route>
      <Route path="claims" element={<Claims />}>
        <Route index element={<ClaimsList />} />
        <Route path="submit" element={<SubmitClaims />} />
        <Route path="form" element={<ClaimsForm />} />
        <Route path="edit/form/:id" element={<ClaimsForm />} />
        <Route path="edit/form/:id/:followUp" element={<ClaimsForm />} />
        <Route path="details" element={<ClaimsDetails />} />
        <Route path="details/:id" element={<ClaimsDetails />} />
        <Route path="history" element={<ClaimHistoryList />} />
        <Route path="gss-report" element={<GssReportMain />} />
        <Route path="claim-report" element={<ClaimReportMain />} />
        <Route path="tpa" element={<TpaClaimsReportMain />} />
        <Route path="uploads" element={<ClaimUploadList />} />
        <Route path="submit-stats" element={<ClaimsSubmitStats />} />
        <Route path="denial/management" element={<DenialManagement />} />
        <Route path="report" element={<ClaimReports />} />
        <Route
          path="report/ready-submission"
          element={<GeneratedReportRoute reportId="claim-ready-submission" />}
        />
        <Route
          path="report/rejection-percentage"
          element={
            <GeneratedReportRoute reportId="claim-rejection-percentage" />
          }
        />
        <Route
          path="report/rejection-report"
          element={<ClaimRejectionReportMain />}
        />
        <Route
          path="report/excel-file"
          element={<GeneratedReportRoute reportId="claim-excel-report" />}
        />
        <Route path="processing" element={<ClaimsProcessing />} />
        <Route path="ucaf" element={<UcafPage />} />
        <Route path="dcaf" element={<DcafPage />} />
        <Route path="error-list" element={<ClaimErrorList />} />
        <Route path="bulk-replace" element={<Navigate to="/claims/diagnosis-bulk-replace" replace />} />
        <Route path="diagnosis-bulk-replace" element={<ClaimDiagnosisBulkReplace />} />
        <Route path="diagnosis-bulk-replace/replace" element={<ClaimDiagnosisBulkReplace />} />
        <Route path="diagnosis-bulk-replace/job/:jobId" element={<ClaimDiagnosisBulkJobDetails />} />
        <Route path="item-bulk-replace" element={<ClaimItemBulkReplace />} />
        <Route path="item-bulk-replace/replace" element={<ClaimItemBulkReplace />} />
        <Route path="item-bulk-replace/job/:jobId" element={<ClaimItemBulkJobDetails />} />
        <Route path="referral-bulk-update" element={<ClaimReferralBulkUpdate />} />
        <Route path="referral-bulk-update/replace" element={<ClaimReferralBulkUpdate />} />
        <Route path="referral-bulk-update/job/:jobId" element={<ClaimReferralBulkJobDetails />} />
        <Route path="bulk-cancel" element={<ClaimsBulkPage action="cancel" />} />
        <Route path="bulk-ready" element={<ClaimsBulkPage action="ready" />} />
        <Route path="ai-agent" element={<ClaimsAiAgent />} />

      </Route>
      <Route path="communications" element={<Communications />}>
        <Route index element={<CommunicationsList />} />
      </Route>
      <Route path="policy" element={<Policy />}>
        <Route index element={<MainPage />} />
      </Route>
      <Route path="payer-managment" element={<Index />}>
        <Route index element={<PayerManagement />} />
        <Route path="form" element={<PayerManagementForm />} />
      </Route>
      <Route path="cancellation" element={<Cancellation />}>
        <Route index element={<CancellationList />} />
      </Route>
      <Route path="physicians" element={<Physician />}>
        <Route index element={<PhysiciansList />} />
        <Route path="form" element={<PhysiciansForm />} />
        <Route path="edit/form/:id" element={<PhysiciansForm />} />
      </Route>

      <Route path="/help-desk" element={<HelpDeskIndex />}>
        <Route index element={<HelpDesk />} />
        <Route path="aramco" element={<AramcoHelpDesk />} />
      </Route>
      <Route path="price-list" element={<PriceList />}>
        <Route index element={<PriceListMain />} />

        <Route path="form" element={<CreatePriceListForm />} />
        <Route
          path="specific/:payerId/:effectiveDate/:payerName"
          element={<PriceListSpecificPayer />}
        />
      </Route>
      <Route path="payments" element={<Payments />}>
        <Route index element={<PaymentsList />} />
        <Route path='details' element={<PaymentDetails />} />
      </Route>
      <Route path="reports" element={<MainReports />}>
        <Route index element={<ReportCard />} />
      </Route>
      <Route path="ocr" element={<Ocr />}>
        <Route index element={<OcrMain />} />
      </Route>
      <Route
        path="sfda-medicine"
        element={
          user?.RoleId === "12" ? (
            <SfdaMedicineIndex />
          ) : (
            <Navigate to="/dashboard" replace />
          )
        }
      >
        <Route index element={<NewSfdaMedicineList />} />
        <Route path="form" element={<NewSfdaMedicineForm />} />
        <Route path="form/:id" element={<NewSfdaMedicineForm />} />
        <Route path="detail/:id" element={<SfdaMedicineDetail />} />
      </Route>
      <Route
        path="icd-codes"
        element={
          user?.RoleId === "12" ? (
            <IcdCodesList />
          ) : (
            <Navigate to="/dashboard" replace />
          )
        }
      />
      <Route path="super-admin" element={<SuperAdmin />}>
        <Route path="user-management" element={<UserManagement />} />
        <Route path="preauth-update" element={<PreAuthUpdate />} />
        <Route path="sfda-medicine">
          <Route index element={<SfdaMedicineList />} />
          <Route path="form" element={<SfdaMedicineForm />} />
        </Route>
      </Route>
      <Route path="reports-summary" element={<ReportSummary />} />
      <Route path="integration-logs" element={<IntegrationLogs />} />
      <Route path="nhic" element={<NHIC />}>
        <Route index element={<NHICSettings />} />
        <Route path="settings" element={<NHICSettings />} />
        <Route path="lookup" element={<HealthIDLookup />} />
      </Route>
      <Route path="*" element={<Navigate to="dashboard" />} />
    </Routes>
  );
}

export default Router;
